<template>
  <div class="logo">
    <v-avatar class="profile" tile v-if="school.logoUrl" :size="size">
       <img contain :src="school.logoUrl" />
    </v-avatar>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: ["school", "size"],
  data: () => ({
    color: [
      "000080",
      "008080",
      "800080",
      "008000",
      "808000",
      "800000",
      "808080",
      "0000FF",
      "00FFFF",
    ],
    randomColor: null,
  }),
  created() {
    //
  },
  mounted() {
    this.randomColor =
      this.color[Math.floor(Math.random() * this.color.length)];
  },
  methods: {
    //
  },
};
</script>
<style>
.logo {
  display: inline-block !important;
}
</style>